<template>
  <div>
    <section id="wat-wij-doen" class="content-wrapper page">
      <section class="row header">
        <ul class="breadcrumb">
          <li><router-link class="link" to="/">Home</router-link></li>
          <li>
            <router-link to="/wat-wij-doen"
              ><inline-svg
                src="/images/icons/chevron-right-solid.svg"
              ></inline-svg
              >Wat wij doen</router-link
            >
          </li>
          <li>
            <inline-svg src="/images/icons/chevron-right-solid.svg"></inline-svg
            >Print uitbesteden
          </li>
        </ul>

        <div class="col text">
          <h1>Print uitbesteden voor professionals</h1>
          <p>
            Als full service grafisch dienstverlener verzorgt Koninklijke Rijnja
            meer dan 160.000 printopdrachten per jaar, vanuit vijf locaties
            verspreid over het land. Dit doen wij voor ruim 4.000 professionals
            in alle sectoren, van bedrijfsleven, bouw, overheid tot onderwijs.
            Bent u toe aan het uitbesteden van uw print en reproopdrachten? Neem
            contact op voor een heldere kijk op wat wij u uit handen kunnen
            nemen:
          </p>
          <a class="link-button top-button" href="#contact"
            >Neem contact met ons op</a
          >
          <h1>Wij regelen het van A tot Z</h1>
          <p>
            Onze professionele en ervaren vakmensen denken proactief mee wanneer
            u overweegt print uit te besteden. Wij adviseren en richten voor u
            een op maat gemaakt bestelportal in. In úw huisstijl, met úw
            producten en volledig in lijn met de wensen en eisen van uw
            administratieve organisatie. Vanaf dat moment bent u klaar voor ons
            super efficiënte klik & klaar bestelproces.
          </p>
          <h1>Print uitbesteden is kostenbesparend</h1>
          <p>
            Het sommetje is eenvoudig te maken. Professioneel printen
            uitbesteden betekent besparen op fysieke ruimte van een
            reproafdeling en alle vaste kosten die met printen te maken hebben.
            Naast het flexibiliseren van vaste kosten zorgen wij voor een
            transparante en vlotte administratieve afhandeling. Deze digitale
            afhandeling zorgt voor overzicht welke kosten er zijn gemaakt voor
            welk project en door welke afdeling.
          </p>
        </div>
        <div class="col header-circle-image">
          <div class="rijnja-amsterdam"></div>
          <!-- <printen-en-meer></printen-en-meer> -->
        </div>
      </section>

      <section class="row image-row">
        <img
          class=""
          src="@/images/pages/rijnja-besteld-en-geleverd-door-heel-nederland.svg"
        />
      </section>

      <section class="row">
        <div class="col text">
          <h2>Makkelijk en snel</h2>
          <p>
            Print uitbesteden is bij ons in betrouwbare, veilige en ervaren
            handen. Wij voeren alle printopdrachten uit in eigen beheer. Onder
            supervisie van uw persoonlijke contactpersoon bij ons, verzorgen wij
            uw print- en repro-opdrachten makkelijk en snel van de voorbereiding
            tot de distributie met eigen koeriers en levering binnen een
            werkdag.
          </p>
        </div>

        <div class="col text">
          <h2>Betrouwbare kwaliteit</h2>
          <p>
            Als marktleider investeren wij voortdurend in vernieuwende
            technologie en duurzame printtechnieken voor veilige en innovatieve
            online-oplossingen. Wij werken volgens de hoogste en nieuwste
            kwaliteits- en milieumanagementnormen. Vanzelfsprekend zijn wij ISO
            9001:2015 en ISO 14001:2015 gecertificeerd. We waarborgen de
            beveiliging en vertrouwelijkheid van uw bestanden en gegevens
            gedurende het gehele proces. Niet voor niets zijn wij gecertificeerd
            volgens de nieuwste norm, ISO 27001:2022.
            <router-link class="link-text" to="/home#voor-wie"
              >Talloze tevreden opdrachtgevers
            </router-link>
            gingen u voor.
          </p>
        </div>
      </section>
      <div class="anchor-tag" id="contact"></div>
      <section class="row" id="">
        <div class="col-single">
          <h1>Wilt u meer weten over onze diensten?</h1>
          <p>
            Benieuwd naar wat Koninklijke Rijnja voor u kan betekenen? Neem dan
            contact met ons op via onderstaand formulier.
          </p>

          <contact-form
            recipient="verkoop@rijnja.nl"
            class="form"
            subject="Informatieaanvraag diensten"
            conversion-id="McMQCKuxhJwYEKDetesD"
          ></contact-form>
          <p>
            Wilt u een van onze vestigingen direct bereiken? Bekijk de
            contactgegevens dan op onze
            <router-link class="link-text" to="/contact"
              >contactpagina</router-link
            >.
          </p>
        </div>
      </section>
    </section>
    <site-footer></site-footer>
  </div>
</template>

<script>
import ContactForm from '../../components/ContactForm.vue'
import SiteFooter from '../../components/SiteFooter.vue'
import PrintenEnMeer from './PrintenEnMeer.vue'
export default {
  components: { SiteFooter, PrintenEnMeer, ContactForm }
}
</script>

<style lang="scss" scoped>
.top-button {
  margin-bottom: 35px;
}
.archiveren {
  max-width: 360px;
}
.bestellen-bezorgen {
  max-width: 375px;
}

.kwaliteit {
  max-width: 370px;
}

.security {
  max-width: 400px;
}

.printstore {
  max-width: 365px;
}

.portals {
  max-width: 450px;
}

.form {
  margin: 20px 0;
}

.rijnja-amsterdam {
  background-image: url('@/images/pages/rijnja-amsterdam-c.jpg');
  width: 966px;
  height: 966px;
  border-radius: 50%;

  position: absolute;
  //top: -404px;
  top: -300px;
  left: 0;
  background-position: bottom left;
  background-size: contain;
}

.row.image-row {
  padding-top: 20px;
  padding-bottom: 20px;

  img {
    max-width: 755px;
    margin: 0 auto;
    width: 100%;
  }
}
</style>
